<template lang="pug">
  #app
    vue-waterfall-easy(:imgsArr="imgsArr",@scrollLoadImg="fetchImgsData")
      template( scope="props" )
        router-link(:to="{name:'canvas-gsh', params: {md5:props.value.md5}}")
          p.some-info {{ props.value.info }}
</template>

<script>
  import vueWaterfallEasy from 'vue-waterfall-easy'

  export default {
    name: 'app',
    data () {
      return {
        j: 0,
        filterResLen: 0,
        imgsArr: [],
        fetchImgsArr: [],
        md5List: [],
        descList: []
      }
    },
    components: {
      vueWaterfallEasy
    },
    methods: {
      initImgsArr (n, m) {
        // console.log('j:', this.j)
        this.j++
        var arr = []
        for (var i = n; i < m && i < this.filterResLen; i++) {
          arr.push({
            src: `http://thumb.gushuhua.org/${this.md5List[i]}.jpg`,
            info: this.descList[i],
            md5: this.md5List[i]
          })
        }
        return arr
      },
      fetchImgsData () {
        this.imgsArr = this.imgsArr.concat(this.initImgsArr(20 * (this.j - 1), 20 * this.j))
      }
    },
    mounted () {
      let searchList = this.$store.getters.searchList
      // console.log('searchList:', searchList)
      this.filterResLen = searchList.length
      // console.log('len:', this.filterResLen)
      this.md5List = searchList.map(e => e.md5)
      this.descList = searchList.map(e => '【' + e.dynasty + ' ' + e.author + ' ' + e.name + '】')
      this.imgsArr = this.initImgsArr(0, 20)
      this.fetchImgsArr = this.initImgsArr(20 * (this.j - 1), 20 * this.j)
    }
  }
</script>

<style>
  .some-info {
    color: black;
  }

  a {
    text-decoration: none
  }
</style>



// WEBPACK FOOTER //
// Waterfall.vue?65ed96d9